import { useBelowBreakpoint } from "../../hooks/useBelowBreakpoint";

import { SidebarHamburger } from "./icons/SidebarHamburger";
import { SidebarBrandButton } from "./SidebarBrandButton";
import * as theme from "./SidebarTopBar.css";

export interface SidebarTopBarProps {
    title: string;
    menuLabel: string;
    onToggleMenu: () => void;
}

/** Renders nothing above phone width. */
export function SidebarTopBar({
    title,
    menuLabel,
    onToggleMenu,
}: SidebarTopBarProps) {
    const phone = useBelowBreakpoint("md");

    if (!phone) {
        return null;
    }

    return (
        <div data-slot="sidebar-top-bar" className={theme.root}>
            <SidebarBrandButton
                label={menuLabel}
                className={theme.menuButton}
                onClick={onToggleMenu}
            >
                <SidebarHamburger />
            </SidebarBrandButton>
            <span className={theme.title}>{title}</span>
        </div>
    );
}
